/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateLegalAgreementDraftRequest
 */
export interface CreateLegalAgreementDraftRequest {
    /**
     * Initial draft content map of language to content (HTML).
     * Keys must be valid LegalAgreementLanguage values.
     * HTML is stored as authored by Malt admins. User-facing rendering must sanitize or isolate this HTML before injecting it into the DOM.
     * 
     * @type {{ [key: string]: string; }}
     * @memberof CreateLegalAgreementDraftRequest
     */
    contents: { [key: string]: string; };
}

/**
 * Check if a given object implements the CreateLegalAgreementDraftRequest interface.
 */
export function instanceOfCreateLegalAgreementDraftRequest(value: object): value is CreateLegalAgreementDraftRequest {
    if (!('contents' in value) || value['contents'] === undefined) return false;
    return true;
}

export function CreateLegalAgreementDraftRequestFromJSON(json: any): CreateLegalAgreementDraftRequest {
    return CreateLegalAgreementDraftRequestFromJSONTyped(json, false);
}

export function CreateLegalAgreementDraftRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateLegalAgreementDraftRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'contents': json['contents'],
    };
}

export function CreateLegalAgreementDraftRequestToJSON(value?: CreateLegalAgreementDraftRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'contents': value['contents'],
    };
}

